// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1An-G","questions":"styles_questions__1iWpX","footer":"styles_footer__3JWX4"};